/**
 * TBD
 */ export var SPECIAL_HOLIDAY_NET90_TIMERANGE = 'SPECIAL_HOLIDAY_NET90_TIMERANGE';
